import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppStore } from "store/appStore";
import useSetupStore from "store/setupSettingsStore";
import { getLanguages, translateText } from "utils/translationService";
import { textsToTranslate } from "utils/en";
import MainTab from "components/PWATabs/mainTab/MainTab";
import CreativesTab from "components/PWATabs/CreativesTab/CreativesTab";
import DomainTab from "components/PWATabs/domainTab/DomainTab";
import TrackingTab from "components/PWATabs/trackingTab/TrackingTab";
import NameApp from "components/PWATabs/mainTab/NameApp";
import PwaTabs from "components/PWATabs/Tabs";
import PhoneMockup from "components/PhoneMockup";
import PhoneMockupModal from "components/PhoneMockupModal";
import Eye from "assets/icons/Eye";
import PhoneContentPwa from "components/PWATemplate/PhoneContentPwa";
import useRouteChange from "hooks/useRouteChange";
import useIdStore from "store/pwaId";

function PWACreatePage() {
  const [languages, setLanguages] = useState(null);
  const { appData, clearAppData, saveAppData } = useAppStore();
  const { clearId } = useIdStore();
  const [openModal, setOpenModal] = useState(false);
  const [value, setValue] = useState(0);
  const setStepStatus = useSetupStore((state) => state.setStepStatus);

  useRouteChange(() => {
    clearAppData();
    localStorage.removeItem("tmpDomainID");
    setValue(0);
  });

  useEffect(() => {
    const stepNames = ["main", "creatives", "domain", "tracking"];
    const currentStep: any = stepNames[value];
    setStepStatus(currentStep, "inprogress");
  }, [value, setStepStatus]);

  useEffect(() => {
    clearId();
    clearAppData();
    const lang = async () => {
      const fetchLanguages: any = await getLanguages();
      setLanguages(fetchLanguages?.languages);
    };
    if (!languages) {
      lang();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const translate = async () => {
      if (appData.language === "en" || appData.language === "en-GB" || appData.language === "EN") {
        saveAppData({ translations: textsToTranslate });
      } else {
        const translatedValues = await translateText(textsToTranslate, appData.language);
        saveAppData({ translations: translatedValues });
      }
    };
    if (appData.language) {
      void translate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appData.language]);

  const renderTabContent = () => {
    switch (value) {
      case 0:
        return <MainTab setValue={setValue} appData={appData} languages={languages} />;
      case 1:
        return <CreativesTab setValue={setValue} />;
      case 2:
        return <DomainTab setValue={setValue} />;
      case 3:
        return <TrackingTab />;
      default:
        return null;
    }
  };

  return (
    <>
      <>
        <NameApp />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <PwaTabs setValue={setValue} renderTabContent={renderTabContent} value={value} />
          </Box>

          {value !== 2 && (
            <>
              <Box
                sx={{
                  display: { xs: "none", xl: "block" },
                  marginTop: "136px",
                  marginLeft: "26px",
                  height: "fit-content",
                  position: "sticky",
                  top: "10%",
                  border: "1px solid #EEEEEE",
                  borderRadius: "8px",
                  padding: "40px 65px",
                }}
              >
                <PhoneMockup>
                  <PhoneContentPwa />
                </PhoneMockup>
              </Box>
              <Box
                onClick={() => setOpenModal(true)}
                sx={{
                  display: { xs: "flex", xl: "none" },
                  minWidth: "40px",
                  width: { xs: "40px", md: "48px" },
                  height: { xs: "40px", md: "48px" },
                  borderBottomLeftRadius: "8px",
                  borderTopLeftRadius: "8px",
                  background: "#F4701B",
                  marginTop: { xs: "64px", md: "68px" },
                  marginLeft: { xs: "-24px", md: "-24px" },
                  marginRight: { xs: "-16px", md: "-24px" },
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  position: "sticky",
                  top: "10px",

                  "& svg": { width: { xs: "22px", md: "26px" }, height: { xs: "22px", md: "26px" } },
                }}
              >
                <Eye color={"#fff"} />
              </Box>
            </>
          )}
        </Box>
      </>
      <PhoneMockupModal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
}
export default PWACreatePage;
